// extracted by mini-css-extract-plugin
export var active = "_c9-2";
export var recordingDot = "_c9-1";
export var recordingIndicator = "_c9-0";